import {get} from "../../../api/commonAPI";
import {NEWSLETTER} from "../../../api/apiPaths";
import {
    DOWNLOAD_NEWSLETTER_CSV, DOWNLOAD_NEWSLETTER_CSV_FAILS, DOWNLOAD_NEWSLETTER_CSV_SUCCESS,
    FETCH_NEWSLETTER,
    FETCH_NEWSLETTER_FAILS,
    FETCH_NEWSLETTER_SUCCESS
} from "./NewsLetterActionType";
const FileSaver = require('file-saver');

export const getAllNewsletters =(country, pageSize, page) => {
    return dispatch => {
        dispatch({
            type: FETCH_NEWSLETTER
        });
        get(`${NEWSLETTER}?countries=${country}&size=${pageSize}&page=${page}`)
            .then(res => {
                dispatch({
                    type: FETCH_NEWSLETTER_SUCCESS,
                    payload: res.data
                });
            })
            .catch(error => {
                dispatch({
                    type: FETCH_NEWSLETTER_FAILS,
                    payload: error
                });
            });
    };
};

export const downloadCSV =(country, date) => {
    return dispatch => {
        dispatch({
            type: DOWNLOAD_NEWSLETTER_CSV
        });
        get(`${NEWSLETTER}/csv?countries=${country}`)
            .then(res => {
                const fetchedResponse = new Blob([res.data], {type: "csv/plain;charset=utf-8"});
                FileSaver.saveAs(fetchedResponse, `newsLetter-${date}.csv`);
                dispatch({
                    type: DOWNLOAD_NEWSLETTER_CSV_SUCCESS,
                    payload: res.data
                });
            })
            .catch(error => {
                dispatch({
                    type: DOWNLOAD_NEWSLETTER_CSV_FAILS,
                    payload: error
                });
            });
    };
};